export default __webpack_public_path__ + "static/media/icon_3.e8d61e25.png";